import { useContext } from 'react';
import ConditionLogicBox from './ConditionLogicBox';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledConditionBox = styled.div.withConfig({
  displayName: "ConditionBox__StyledConditionBox",
  componentId: "sc-1a7gik7-0"
})(({
  theme,
  useOnePanel,
  showBorderBox,
  withError
}) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: showBorderBox ? theme.borderWidth[100] : undefined,
    borderStyle: 'solid',
    borderColor: withError ? theme.color['border-alert-default'] : theme.color['border-core-hover'],
    borderRadius: showBorderBox ? theme.borderRadius[100] : undefined,
    outline: withError && !useOnePanel ? `1px solid ${theme.color['border-alert-default']}` : undefined
  };
});
const StyledConditionContentBox = styled.div.withConfig({
  displayName: "ConditionBox__StyledConditionContentBox",
  componentId: "sc-1a7gik7-1"
})(({
  withoutLogicBox,
  showBorderBox,
  size,
  theme
}) => {
  let conditionPadding = undefined;
  if (showBorderBox) {
    conditionPadding = theme.space[300];
  } else if (size === 'sm') {
    conditionPadding = `6px ${theme.space[250]}`;
  } else if (size === 'xs') {
    conditionPadding = '5px 0';
  }
  return {
    backgroundColor: theme.color['fill-surface-default'],
    borderRadius: withoutLogicBox ? theme.borderRadius[100] : `0 0 ${theme.borderRadius[100]} ${theme.borderRadius[100]}`,
    padding: conditionPadding
  };
});
const ConditionBox = props => {
  const {
    children,
    conditionPath,
    logicOperator,
    size = 'md',
    hasError,
    hasLogicBox = false,
    isRefinement = false
  } = props;
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized classname is selected by ancestor style rules
    _jsxs(StyledConditionBox, {
      className: "condition-box",
      useOnePanel: !!useOnePanel,
      showBorderBox: !isRefinement,
      withError: !!hasError,
      children: [hasLogicBox && /*#__PURE__*/_jsx(ConditionLogicBox, {
        conditionPath: conditionPath,
        logicOperator: logicOperator
      }), /*#__PURE__*/_jsx(StyledConditionContentBox, {
        className: "condition-content-box",
        size: size,
        showBorderBox: !isRefinement,
        withoutLogicBox: !hasLogicBox,
        children: children
      })]
    })
  );
};
export default ConditionBox;